import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useApp } from '../../context/AppContext';

export function RequireMenu({ menu, children }) {
  const app = useApp();
  const allowed = app.can(menu);
  useEffect(() => { if (!allowed) toast.error('Your role does not have access to that area.', { id: 'menu-denied' }); }, [allowed]);
  if (!allowed) return <Navigate to="/dashboard" replace />;
  return children;
}
